import { css, styled } from 'styled-components';

import { COLLAPSING_TRANSITION, NAVIGATION_WIDTH_COLLAPSED } from '@/js/libs/ui/src/V2/Components/PuzzleNav/constants';
import { ExternalLink } from '@/js/libs/ui/src/V2/Controls/Link';

const STATUS_ICON_SIZE_VALUE = 18;
const STATUS_ICON_SIZE = `${STATUS_ICON_SIZE_VALUE}px`;
const FOOTER_PADDING = '16px';

export { STATUS_ICON_SIZE_VALUE };

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px ${FOOTER_PADDING};
  background-color: ${({ theme }) => theme.colors.grey01_1};
  border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
`;

export const StatusLink = styled(ExternalLink)<{ $isCollapsedNav: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ $isCollapsedNav }) =>
    $isCollapsedNav ? `9px calc((${NAVIGATION_WIDTH_COLLAPSED} - ${STATUS_ICON_SIZE} - ${FOOTER_PADDING} * 2) / 2)` : '9px'};
  margin: 0;
  transition: padding ${COLLAPSING_TRANSITION};
`;

export const ActionGroup = styled.div<{ $isCollapsedNav: boolean }>`
  display: flex;
  align-items: center;
  transition: opacity ${COLLAPSING_TRANSITION};
  opacity: ${({ $isCollapsedNav }) => ($isCollapsedNav ? 0 : 1)};
  ${({ $isCollapsedNav }) =>
    $isCollapsedNav &&
    css`
      pointer-events: none;
      user-select: none;
      touch-action: none;
    `}
`;
